import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-property-config',
    templateUrl: './property-config.component.html',
    styleUrls: ['./property-config.component.css'],
    standalone: false
})
export class PropertyConfigComponent implements OnInit {
  propertyId: any;
  rateBucketId: any;
  formTitle: any;
  formPropertyCode: any;
  selectedIndex : any = 0;
  filteredCheckInDate: any;
  filteredCheckOutDate: any;

  constructor(
    private router: Router,
		private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title,
    this.formPropertyCode = data.propertyCode,
			this.propertyId = data.propertyId
      this.rateBucketId = data.rateBucketId;
      if(this.propertyId == null)
      {
        this.propertyId = this.activatedRoute.snapshot.paramMap.get('propertyId');
      }
      if(this.rateBucketId == null)
      {
        this.rateBucketId = this.activatedRoute.snapshot.paramMap.get('rateBucketId');
      }
      if(this.activatedRoute.snapshot.paramMap.get('defaultTabIndx'))
      {
        this.selectedIndex = this.activatedRoute.snapshot.paramMap.get('defaultTabIndx');
      }
      if(this.activatedRoute.snapshot.paramMap.get('checkInDate') && this.activatedRoute.snapshot.paramMap.get('checkOutDate'))
      {
        this.filteredCheckInDate = this.activatedRoute.snapshot.paramMap.get('checkInDate');
        this.filteredCheckOutDate = this.activatedRoute.snapshot.paramMap.get('checkOutDate');
      }
   }

  ngOnInit(): void {
  }

  onIndexChange(event)
  {
    this.selectedIndex = event;
  }

}
